import useAppContext from "../../hooks/useAppContext";
import "./otp-manager.css";
import {Button, Tooltip} from "antd";
import {useEffect, useState} from "react";
import {getOtpService} from "../../api/getOtpService";
import useUserContext from "../../hooks/useUserContext";
import LanguagePicker from "../forms/languagePicker/LanguagePicker";
import {BigInput} from "../forms/bigInput/BigInput";
import {updateOtpService} from "../../api/updateOtpService";
import {sendTestOtpMessage} from "../../api/sendTestOtpMessage";
import useToast from "../../hooks/useToast";
import {ToastSkin} from "../../context/ToastContext";

const OtpManager = () => {
    const { selectedDomain } = useUserContext();
    const { data: { waba, shop }, actions: { loadWaba }} = useAppContext();
    const [serviceId, setServiceId] = useState();
    const [friendlyName, setFriendlyName] = useState('');
    const [language, setLanguage] = useState('en-US');
    const [isLoading, setIsLoading] = useState(false);
    const [isSendingTest, setIsSendingTest] = useState(false);
    const { showToast } = useToast();

    const sendTestMessage = async () => {
        if(selectedDomain) {
            setIsSendingTest(true);
            const response = await sendTestOtpMessage(selectedDomain);
            console.log("response: ", response);
            if(response.status === 200) {
                showToast({ skin: ToastSkin.approval, text: 'Test message was successfully sent!' });
            } else {
                showToast({ skin: ToastSkin.error, text: 'Test message was failed to be sent, please check if you have a testing phone number in the Configuration section (Settings screen), and try again.' })
            }
            setIsSendingTest(false);
        }
    }

    const getOtp = async () => {
        if(selectedDomain) {
            setIsLoading(true);
            const response = await getOtpService(selectedDomain);
            if(response?.data) {
                setFriendlyName(response.data.friendlyName);
                setLanguage(response.data.language);
            }
            setIsLoading(false);
        }
    }

    const updateOtp = async () => {
        if(selectedDomain) {
            setIsLoading(true);
            const response = await updateOtpService(selectedDomain, friendlyName, language);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        setServiceId(waba.data?.waba?.providerOtpServiceId);
        waba?.data?.waba?.otpLanguage && setLanguage(waba.data.waba.otpLanguage);
        shop?.data?.friendlyName && !friendlyName && setFriendlyName(shop.data.friendlyName);
    }, [waba, shop]);

    useEffect(() => {
        if(serviceId) {
            getOtp();
        }
    }, [serviceId]);

    return (
        <div className="otp-manager-container">
            <div className="description">
                OTP Verification sends a one-time code to a user’s phone to confirm their identity.
                Choose your business name (subject to carrier approval) and the language of the message.
                You can enable it automatically in forms like support widgets or subscription flows—and also trigger it manually wherever you need to verify a user’s phone number.
            </div>

            <div className="form">
                <BigInput isDisabled={isLoading} value={friendlyName} setValue={setFriendlyName} description="Company name in message. The carrier may decide to ignore this name." />
                <LanguagePicker disabled={isLoading} selectedKey={language} onClick={setLanguage} label="The language in which you OTP messages will be sent" />
            </div>
            <div className="actions">
                <Tooltip title="Make sure you set a testing phone number on the Configuration section in the Settings screen">
                    <Button type="default" size="large" disabled={isLoading || !serviceId} loading={isSendingTest} onClick={sendTestMessage}>Send test message</Button>
                </Tooltip>
                <Button type="primary" size="large" loading={isLoading} onClick={updateOtp}>Update OTP Settings</Button>
            </div>
        </div>
    );
}

export default OtpManager;